const IconTab1 = () => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3999 17.25L9.79588 16.4905C8.49215 15.8738 7.6499 14.5429 7.6499 13.1009V8.25H15.1499V13.1009C15.1499 14.543 14.3077 15.8738 13.0039 16.4905L11.3999 17.25ZM9.1499 9.75V13.1009C9.1499 13.9658 9.65525 14.7642 10.4375 15.134L11.3999 15.5896L12.3623 15.134C13.1446 14.7641 13.6499 13.9658 13.6499 13.1009V9.75H9.1499Z"
      fill="currentColor"
    />
    <path
      d="M2.4905 13.2422C2.88838 12.9726 3.1499 12.5167 3.1499 12C3.1499 11.1716 2.47828 10.5 1.6499 10.5C0.821527 10.5 0.149902 11.1716 0.149902 12C0.149902 12.5914 0.495427 13.0983 0.992902 13.3425C1.5023 17.343 4.2533 20.7283 8.16935 21.9935L8.63038 20.566C5.30375 19.4916 2.95723 16.6314 2.4905 13.2422Z"
      fill="currentColor"
    />
    <path
      d="M21.3934 15.2307L19.9659 14.7693C18.8913 18.0959 16.0314 20.4427 12.6421 20.9092C12.3724 20.5114 11.9169 20.25 11.4 20.25C10.5716 20.25 9.89997 20.9216 9.89997 21.75C9.89997 22.5784 10.5716 23.25 11.4 23.25C11.9916 23.25 12.4983 22.9047 12.7423 22.407C16.7428 21.8976 20.1282 19.1466 21.3934 15.2307Z"
      fill="currentColor"
    />
    <path
      d="M21.8069 10.6575C21.2975 6.65699 18.5465 3.27172 14.6304 2.00647L14.1694 3.43394C17.496 4.50839 19.8426 7.36852 20.3093 10.7578C19.9114 11.0273 19.6499 11.4832 19.6499 11.9999C19.6499 12.8283 20.3215 13.4999 21.1499 13.4999C21.9783 13.4999 22.6499 12.8283 22.6499 11.9999C22.6499 11.4085 22.3046 10.9017 21.8069 10.6575Z"
      fill="currentColor"
    />
    <path
      d="M11.3999 0.75C10.8083 0.75 10.3016 1.0953 10.0575 1.593C6.05705 2.1024 2.67162 4.8534 1.40637 8.7693L2.83385 9.2307C3.90852 5.90407 6.76842 3.55732 10.1577 3.09083C10.4274 3.48855 10.8829 3.75 11.3998 3.75C12.2282 3.75 12.8998 3.07838 12.8998 2.25C12.8998 1.42162 12.2283 0.75 11.3999 0.75Z"
      fill="currentColor"
    />
  </svg>
)

export default IconTab1
